import React from 'react';
import { AlertCircleIcon, CheckCircle2Icon, RefreshCwIcon } from 'lucide-react';
const integrations = [{
  name: 'Munsoft',
  type: 'Municipal ERP',
  status: 'Connected',
  lastSync: '10 mins ago',
  logo: 'M',
  color: 'bg-blue-600'
}, {
  name: 'SAP',
  type: 'Enterprise ERP',
  status: 'Connected',
  lastSync: '1 hour ago',
  logo: 'SAP',
  color: 'bg-blue-500'
}, {
  name: 'Xero',
  type: 'Accounting',
  status: 'Syncing...',
  lastSync: 'In progress',
  logo: 'X',
  color: 'bg-cyan-500'
}, {
  name: 'QuickBooks',
  type: 'Accounting',
  status: 'Disconnected',
  lastSync: '2 days ago',
  logo: 'QB',
  color: 'bg-green-600'
}];
export function BillingIntegrations() {
  return <div className="p-8 max-w-7xl mx-auto animate-in fade-in duration-500" data-id="element-533">
      {/* Header */}
      <div className="mb-8" data-id="element-534">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-535">
          Billing Integrations
        </h1>
        <p className="text-gray-500" data-id="element-536">
          Manage automated billing sync with financial and ERP systems.
        </p>
      </div>

      <div className="space-y-6" data-id="element-537">
        <div className="bg-blue-50 border border-blue-100 p-4 rounded-none flex items-start gap-3 mb-6" data-id="element-538">
          <AlertCircleIcon className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" data-id="element-539" />
          <div data-id="element-540">
            <h4 className="text-sm font-bold text-blue-900" data-id="element-541">
              Automated Billing Sync
            </h4>
            <p className="text-sm text-blue-800 mt-1" data-id="element-542">
              MAVIS automatically syncs revenue data, prepaid token sales, and
              LPU billing runs with your connected financial systems daily at
              00:00.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-543">
          {integrations.map(integration => <div key={integration.name} className="bg-white border border-gray-200 shadow-sm rounded-none p-6" data-id="element-544">

              <div className="flex justify-between items-start mb-6" data-id="element-545">
                <div className="flex items-center gap-3" data-id="element-546">
                  <div className={`w-12 h-12 ${integration.color} text-white font-bold text-xl flex items-center justify-center rounded-none shadow-sm`} data-id="element-547">

                    {integration.logo}
                  </div>
                  <div data-id="element-548">
                    <h3 className="font-bold text-gray-900 text-lg" data-id="element-549">
                      {integration.name}
                    </h3>
                    <p className="text-xs text-gray-500" data-id="element-550">{integration.type}</p>
                  </div>
                </div>
                <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-none text-[10px] font-bold uppercase ${integration.status === 'Connected' ? 'bg-green-100 text-green-800' : integration.status === 'Syncing...' ? 'bg-blue-100 text-blue-800 animate-pulse' : 'bg-gray-100 text-gray-600'}`} data-id="element-551">

                  {integration.status === 'Connected' && <CheckCircle2Icon className="w-3 h-3" data-id="element-552" />}
                  {integration.status === 'Syncing...' && <RefreshCwIcon className="w-3 h-3 animate-spin" data-id="element-553" />}
                  {integration.status}
                </span>
              </div>

              <div className="space-y-4" data-id="element-554">
                <div className="flex justify-between items-center text-sm" data-id="element-555">
                  <span className="text-gray-500" data-id="element-556">Last Sync</span>
                  <span className="font-medium text-gray-900" data-id="element-557">
                    {integration.lastSync}
                  </span>
                </div>
                <div className="flex justify-between items-center text-sm" data-id="element-558">
                  <span className="text-gray-500" data-id="element-559">Auto-sync</span>
                  <span className="font-medium text-gray-900" data-id="element-560">Enabled</span>
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-gray-100 flex gap-3" data-id="element-561">
                <button className={`flex-1 py-2 text-sm font-medium rounded-none transition-colors border ${integration.status === 'Disconnected' ? 'bg-mavis-teal text-white border-mavis-teal hover:bg-mavis-teal/90' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`} data-id="element-562">

                  {integration.status === 'Disconnected' ? 'Connect' : 'Configure'}
                </button>
                {integration.status === 'Connected' && <button className="flex-1 py-2 text-sm font-medium rounded-none transition-colors bg-white text-mavis-teal border border-mavis-teal hover:bg-mavis-teal/5" data-id="element-563">
                    Sync Now
                  </button>}
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}